<div class="login-box">
  <h2>{{ trans('auth.labels.login') }}</h2>
  <p>{{ trans('auth.labels.loginPrompt') }}</p>
  <form (submit)="$event.preventDefault(); next()">
    <app-string-input [label]="trans('auth.form.email')" [autofocus]="true" type="email" name="email" autocomplete="email" [(value)]="login.email" [hasError]="val.hasError('email')" [disabled]="isLoading">
      <app-form-error *ngIf="val.hasError('email')">
        <app-tmapper
          [key]="val.getError('email')"
          [default]="defaultEmailError"
          [context]="{}"
          [map]="{
            NO_PASSWORD: noPassword,
            DISABLED_USER: disabledUser,
            NO_USER: noUser,
            SOCIAL: social,
            SOCIAL_GOOGLE: socialGoogle,
            EMAIL_REQUIRED: emailRequired,
            EMAIL_INVALID: emailInvalid
          }"
        ></app-tmapper>
      </app-form-error>
    </app-string-input>
    <input style="display: none" type="password" name="password" id="password" [(value)]="login.password" autocomplete="current-password" />
    <app-button type="filled-secondary" [isLoading]="isLoading">{{ trans('general.next') }}</app-button>
  </form>
  <div *ngIf="auth.hasAccounts" class="backLink" routerLink="/login">{{ trans('general.back') }}</div>
</div>
<ng-template #defaultEmailError>
  <span>{{ val.getError('email') }}</span>
</ng-template>
<ng-template #noPassword>
  <span>{{ trans('auth.errors.noPasswordSet') }} <a routerLink="/login/password-reset/email">{{ trans('auth.errors.noPasswordSetLink') }}</a></span>
</ng-template>
<ng-template #disabledUser>
  <span>{{ trans('auth.errors.notActivated') }} <a routerLink="/login/register/activate/resend">{{ trans('auth.errors.notActivatedLink') }}</a></span>
</ng-template>
<ng-template #social>
  <span>{{ trans('auth.errors.useSocialLogin') }}</span>
</ng-template>
<ng-template #noUser>
  <span>{{ trans('auth.errors.noUser') }} <a routerLink="/login/register">{{ trans('auth.errors.noUserLink') }}</a></span>
</ng-template>
<ng-template #socialGoogle>
  <span>{{ trans('auth.errors.useGoogleLogin') }} <a href="javascript:void(0)" (click)="googleAuth.signIn()">{{ trans('auth.errors.useGoogleLoginLink') }}</a></span>
</ng-template>
<ng-template #emailInvalid>
  <span>{{ trans('auth.errors.invalidEmail') }}</span>
</ng-template>
<ng-template #emailRequired>
  <span>{{ trans('auth.errors.requiredEmail') }}</span>
</ng-template>
